<template>
  <div v-if="!hideFooter">
    <div style="height: 53px;">
<!--       <span style="display: none;">{{VuexCurrentTab}}</span>
 -->    </div>
    <div class="stickToBottom">
      <tabbar @tabbar-text-active-color="444444" v-model="currentTab" slot="bottom">
        <tabbar-item v-if="isRedirect == 'true'" @on-item-click="$router.push('/login')">
          <i slot="icon" class="footerIcon fa fa-sign-in-alt"></i>
          <span slot="label">{{"登入"}}</span>
        </tabbar-item>
        <tabbar-item v-if="isShopOwner" @on-item-click="$router.push('/product')">
          <i slot="icon" class="footerIcon fa fa-clipboard-list"></i>
          <span slot="label">{{$t('kol.footer.fullList')}}</span>
        </tabbar-item>
        <tabbar-item show-dot @on-item-click="goToMyShop()">
          <i slot="icon" class="footerIcon fa fa-store"></i>
          <span slot="label">{{$t('kol.footer.shop')}}</span>
        </tabbar-item>
        <!-- link='/component/demo' -->
        <tabbar-item :badge="totalQuantity" @on-item-click="$router.push('/cart')">
          <i slot="icon" class="footerIcon fa fa-shopping-cart"></i>
          <span slot="label">{{$t('kol.footer.cart')}}</span>
        </tabbar-item>
        <tabbar-item @on-item-click="$router.push('/account')">
          <i slot="icon" class="footerIcon fa fa-user"></i>
          <span slot="label">{{$t('kol.footer.account')}}</span>
        </tabbar-item>
      </tabbar>
    </div>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import { Tabbar, TabbarItem } from 'vux'
import $ from 'jquery'
import Cookies from 'js-cookie'

var routerRootPath = [];

export default {
  name: 'MPFooter',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    Tabbar,
    TabbarItem
  },
  props: {},
  data() {
    return {
      currentTab: 0,
    }
  },
  created() {
    this.updateFooterTab(this.$router.currentRoute);
  },
  mounted() {
   if (!this.isShopOwner) {
        routerRootPath = [
          'login', 'shop', 'cart', 'account'
        ];
      } else {
        routerRootPath = [
          'product', 'shop', 'cart', 'account'
        ];
      }
  },
  watch: {
    $route(destPath, fromPath) {
      this.updateFooterTab(destPath);
      // this.$store.commit('resetSearchParam');
    },
    currentRole(newVal, oldVal) {

    },
  },
  computed: {
    currentRole() {
      return Cookies.get('role');
    },
    isShopOwner() {
      let result = true;
      let role = this.currentRole;
      let currentShopLink = this.$router.currentRoute.query.link;
      let cookieShopLink = Cookies.get('shopLink');

      if(role != "K" && role !="R"){
          result = false;
      }
      if(currentShopLink){
        if(currentShopLink != cookieShopLink){
          Cookies.set('otherShopLink',currentShopLink);
          return false;
        }
      }

      return result;
    },
    // VuexCurrentTab(){
    //     this.currentTab = this.$store.getters.getFooterCurrentTab;
    //   return this.$store.getters.getFooterCurrentTab;
    // },
    hideFooter() {
      return this.$store.state.hideFooter;
    },
    totalQuantity() {
      if (this.$store.getters.totalQuantity == 0) {
        return '';
      }
      return this.$store.getters.totalQuantity + '';
    },
    isRedirect() {
      return Cookies.get('redirect');
    },
  },
  methods: {
    updateFooterTab(destPath) {

      this.$store.commit('updateRouteStatus', destPath);
      let dest = destPath.path + "";
      dest = dest.split('/');
      // console.log(routerRootPath);
      $.each(routerRootPath, (index, path)=>{
        // console.log(path);
        if (path == dest[1]) {
          this.currentTab = index;
        }
      })
    },
    goToMyShop() {
      let shopLink = '';
      if(this.isShopOwner){
          shopLink = Cookies.get('shopLink');
      }else{
          shopLink = Cookies.get('otherShopLink');
      }

      this.$router.push({
        path: '/shop/list',
        query: { link: shopLink }
      })
    },

    goToModule(path){ // 'cart', ''


    }

  },
}

</script>
<style type="text/css">
.weui-tabbar__label {
  margin-bottom: 0rem;
}

.weui-tabbar__item {
  margin-top: 0.2rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer/MPFooter.vue